import React from 'react';
import { css } from '@emotion/react';
import Checkbox from '@mui/material/Checkbox';
import { useTranslation } from 'react-i18next';
import { color } from '../../styles';
import { CareRecordFormHook } from '@/hooks/useCareRecordForm';

interface Props {
  form: CareRecordFormHook;
}

const AlignCenter = css`
  display: flex;
  align-items: center;
`;

const StyledCheckbox = css`
  padding: 6px;
`;

const CheckboxLabel = (isDisabled: boolean) => css`
  color: ${isDisabled ? color.thin_gray : color.black};
  cursor: ${isDisabled ? 'none' : 'pointer'};
`;

export const CareRecordUrineLeakOutCheckSection = ({ form }: Props) => {
  const { t } = useTranslation();
  const isLeakOutUrineDisabled = form.isUrineMetaDisabled;
  const checkboxId = form.isDisplayAdvancedForm ? 'detail-leak-out-urine-checkbox' : 'basic-leak-out-urine-checkbox';

  React.useEffect(() => {
    if (isLeakOutUrineDisabled) {
      if (form.isUrinatedToilet !== null || form.padUrineVolumeType !== null) {
        form.setIsLeakOutUrine(false);
      } else {
        form.setIsLeakOutUrine(null);
      }
    }
  }, [isLeakOutUrineDisabled, form.isUrinatedToilet, form.padUrineVolumeType, form.setIsLeakOutUrine]);

  return (
    <div css={AlignCenter}>
      <Checkbox
        id={checkboxId}
        css={StyledCheckbox}
        disabled={isLeakOutUrineDisabled}
        checked={form.isLeakOutUrine ?? false}
        onClick={form.handleCheckLeakOutUrine}
      />
      <label htmlFor={checkboxId} css={CheckboxLabel(isLeakOutUrineDisabled)}>
        {t('clothesAndSheetsAreContaminated', '衣服・シーツ汚染あり')}
      </label>
    </div>
  );
};
